import { T } from '@app/components/translation';

const Overdue = () => (
  <>
    <b>
      <T
        _str="Document is overdue."
        _comment="Text for overdue contract. Visible in contract."
      />
    </b>
    <span> </span>
    <T
      _str="Contact the document owner to extend the signing period."
      _comment="Text for overdue contract. Visible in contract."
    />
  </>
);

export default Overdue;
